import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import LocationMap from '../../components/LocationMap/LocationMap'; 
import ContactCard from '../../components/ContactCard/ContactCard';
import Modal from '../../components/Modal/Modal';
import Footer from '../../components/Footer/Footer'; 
import { FaGlobe, FaStore } from 'react-icons/fa';
import '../../resources/styling/GlobalStyles.css'; 
import './ContactPage.css';
import customerSupportImage from '../../resources/assets/images/customersupport.jpg';

<img src={customerSupportImage} alt="Customer Support" />


const ContactPage = () => {
  const [showExportModal, setShowExportModal] = useState(false);

  const handleExportClick = () => setShowExportModal(true);

  const contactCards = [
    {
      icon: <FaGlobe />,
      title: 'Global Export',
      description:
        'Looking to expand globally? Contact our Export team for tailored solutions and international logistics.',
      buttonText: 'Contact Export',
      onClick: handleExportClick,
    },
    {
      icon: <FaStore />,
      title: 'Style By Kozee',
      description:
        'For design consultations, orders, or custom requests — reach out to our Style By Kozee team.',
      buttonText: 'Contact Style',
      buttonLink: 'https://wa.me/6596366354',
    },
  ];

  // 📨 EmailJS Credentials
  const serviceID = 'service_n3z6umk';
  const templateID = 'template_64gqc2a';
  const userID = 'GVpUrb03rSiCBU9G5';

  return (
    <div className="page-container"> 
      <main className="main-content">
        <section className="contact-header">
        <div className="contact-header-content">
          <div className="contact-text">
            <h1>Get in Touch</h1>
            <p>Whether local or international, we’re committed to supporting your business with responsive, reliable service.</p>
          </div>

          <div className="contact-image">
            <img src={customerSupportImage} alt="Customer Support" />
          </div>
        </div>
        </section>

        <section className="card-section">
          <div className="card-row">
            {contactCards.map((card, index) => (
              <ContactCard
                key={index}
                icon={card.icon}
                title={card.title}
                description={card.description}
                buttonText={card.buttonText}
                buttonLink={card.buttonLink}
                onClick={card.onClick}
              />
            ))}
          </div>
        </section>

        {/* 🔵 Modal with EmailJS Form */}
        <Modal isOpen={showExportModal} onClose={() => setShowExportModal(false)}>
          <h2>Export Inquiry Form</h2>
          <form
            className="export-form"
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                await emailjs.sendForm(
                  serviceID,
                  templateID,
                  e.target,
                  userID
                );
                alert('✅ Your inquiry has been sent!');
                setShowExportModal(false);
                e.target.reset(); // optional: clear form
              } catch (error) {
                console.error('EmailJS Error:', error);
                alert('❌ Failed to send. Please try again.');
              }
            }}
          >
            <input type="text" name="name" placeholder="Your Name" required />
            <input type="email" name="email" placeholder="Your Email" required />
            <input type="text" name="company" placeholder="Company Name" />
            <textarea name="message" placeholder="Your Export Needs..." rows="5" required></textarea>
            <button type="submit">Submit</button>
          </form>
        </Modal>

        <div className="contact-content">
          <LocationMap />
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
